import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router';
///IDIOMAS
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import * as backInter from 'app/auth/auth-data.model';

import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { PreguntasService } from "../preguntas.service";
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";

@Component({
  selector: 'app-reactivos-v3',
  templateUrl: './reactivos-v3.component.html',
  styleUrls: ['./reactivos-v3.component.scss']
})
export class ReactivosV3Component implements OnInit {

  cargando = false;
  changeInfoFin:boolean=false;
  pasoCompleto = false;
  productoCertificar: any;

  guardandoTemplate: boolean;
  idiomasGuardados: Subject<any> = new Subject<any>();
  seccionesGuardadas: Subject<any> = new Subject<any>();
  actualizaJsonTrad: Subject<any> = new Subject<any>();
  statusPaso: Subject<any> = new Subject<any>();

  traduccionesCompletas: boolean;
  traduccionesTab = true;

  numeroGrupos: number;
  numeroPreguntas: number = 0;
  gruposCompletos = true;
  preguntasOpcionesMinimas = true;
  seccionesEspecialesOK = true;
  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  desbloqueoEstatus:boolean=false;
  token:any;

  showHtml:boolean;//variable
  nameUserAdmin:any="";

  tiposSecciones = [
    {clave: 'nps', tipoSeccion: 1, modal: 'NPS', codigoCompletado: '219'},
    {clave: 'reactivos', tipoSeccion: 2, modal: 'REACTIVOS', codigoCompletado: '218'},
    {clave: 'control', tipoSeccion: 3, modal: 'CONTROL', codigoCompletado: '221'},
    {clave: 'demograficos', tipoSeccion: 4, modal: 'DEMOGRAFICOS', codigoCompletado: '213'},
    {clave: 'abiertas', tipoSeccion: 5, modal: 'ABIERTAS', codigoCompletado: '220'},
    {clave: 'forall', tipoSeccion: 6, modal: 'FORALL', codigoCompletado: '212'},
    {clave: 'adicionales', tipoSeccion: 7, modal: 'ADICIONALES', codigoCompletado: '214'}
  ];
  seccionActual: any;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
    private preguntasService: PreguntasService,
    private wizardService: WizardService,
    private activatedRoute: ActivatedRoute,
    private surveyProductService: SurveyProductService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_cerv3.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('userBypass')){
      this.userData=JSON.parse(localStorage.getItem('userBypass'));
      // console.log(this.userData.level);
      if(this.userData.level==3 || this.userData.level==2){
        this.validationUser=true;
        this.nameUserAdmin=this.userData.user;
      }
      else{
        this.validationUser=false;
        this.nameUserAdmin="";
      }
    }




  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(params => {
      this.seccionActual = this.tiposSecciones[this.tiposSecciones.findIndex(item => item.tipoSeccion == params.tipoSeccion)];
      // this.obtieneCertificarActual();
      this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
      // this.surveyProductService.recibidosSurvProd.subscribe((datos:any) => {
      this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
        if(datos.recuperaInformacion == true){
          this.obtieneCertificarActual(datos.productoCertificar);
        }
      });
    });
  }

  // obtieneCertificarActual(){
  //   this.preguntasService.getProdCertAct().subscribe((data:any) => {
  //     console.log("estos son datos que quiero saer ",data);
  //
  //     let prodsCertificar:any[] = data.productosCertificar;
  //
  //     let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
  //     if(indiceProducto != -1){
  //       this.productoCertificar = prodsCertificar[indiceProducto];
  //       console.log(this.productoCertificar);
  //       let datos: any = {
  //           productoId: this.productoCertificar.idCertificar,
  //         };
  //       datos[this.seccionActual.clave] = 1; //agrega el parametro de acuerdo al producto visualizado
  //       this.preguntasService.getStatusProd(datos).subscribe( (data: any) => {
  //         if(data.estatus === 3){
  //           this.pasoCompleto = true;
  //         }
  //         this.statusPaso.next(this.pasoCompleto);
  //       });
  //       this.token=this.productoCertificar.tokenConfig;
  //       this.getStatusEncuesta(this.token);
  //       this.getStatusModal(this.productoCertificar.idCertificar);
  //       this.getEstatusDesbloqueo();
  //     }
  //   }, error  => {
  //     //console.log("error al recuperar certificar vigente");
  //   });
  // }
  obtieneCertificarActual(datosProducto: any){
    this.productoCertificar = datosProducto;
    let datos: any = {
      productoId: this.productoCertificar.idCertificar,
    };
    datos[this.seccionActual.clave] = 1; //agrega el parametro de acuerdo al producto visualizado
    this.preguntasService.getStatusProd(datos).subscribe( (data: any) => {
      if(data.estatus === 3){
        this.pasoCompleto = true;
      }
      this.statusPaso.next(this.pasoCompleto);
    });
    this.token=this.productoCertificar.tokenConfig;
    this.getStatusEncuesta(this.token);
    this.getStatusModal(this.productoCertificar.idCertificar);
    this.getEstatusDesbloqueo();
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getStatusEncuesta(token:any){
    this.changeInfoFin=false
    // console.log("regreso a false  1 una vez mas ",this.changeInfoFin);
  if(token){
    this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
      console.log(data);
      if(data.result.id_status==1){
        this.validationSurvey=true;
      }
      else{
        this.validationSurvey=false;
      }
      this.changeInfoFin=true;
      // console.log("se modifico 1 una vez mas ",this.changeInfoFin);
    });
  }else{
    setTimeout(() => {
      this.changeInfoFin=true;
    }, 2000);
  }
  }

  getStatusModal(datos:any){
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: any) => {
      if(data.estatus==1){
        this.modalInformativo(this.seccionActual.modal);
      }
    });
  }

  updateStatusModal(){
    let datos:any = {
      productoId: this.productoCertificar.idCertificar
    };
    datos[this.seccionActual.clave] = 2; //agrega el parametro de acuerdo al producto visualizado
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  enviaIdiomasGuardados(event:any){
    console.log("evento idiomas :::",event);
    this.idiomasGuardados.next(event);
    this.ocultarPestañaTraducciones(event);
  }


  ocultarPestañaTraducciones(idiomas:any){
    console.log("entroOcultar");
    let idiomasAdicionales: number = 0;
    idiomas.forEach(idioma => {
      if(idioma.tipoIdioma == '0'){
        idiomasAdicionales++;
      }
    });
    if(idiomasAdicionales > 0){
      this.traduccionesTab = true;
    }else{
      this.traduccionesTab=false;
    }
    console.log("adicionaleS:",idiomasAdicionales,"tradTab:",this.traduccionesTab);

  }

  enviaSeccionesGuardadas(event:any){
    this.seccionesGuardadas.next(event);
    this.numeroGrupos = event.seccionesDemo.length;
    if(this.numeroGrupos > 0){
      this.gruposCompletos = true;
      this.seccionesEspecialesOK = true;
      this.preguntasOpcionesMinimas = true;
      event.seccionesDemo.forEach(grupo => {
        //revisa secciones especiales
        if(grupo.typeCustom == 2){
          if(grupo.tagCustom == ''){
            this.seccionesEspecialesOK = false;
          }
        }
        if(grupo.questions.length == 0){
          this.gruposCompletos = false;
        }
        else{
          grupo.questions.forEach(pregunta => {
            if(pregunta.answerType == 1 || pregunta.answerType == 4 || pregunta.answerType == 6){
              if(pregunta.answers){
                if(pregunta.answers.length < 2){  // dos respuestas minimas para estos tipos de pregunta
                  this.preguntasOpcionesMinimas = false;
                }
              }
              else{
                this.preguntasOpcionesMinimas = false;
              }
            }
          });
        }
        this.numeroPreguntas += grupo.questions.length;
      });
    }
    console.log("numeroGrupos:",this.numeroGrupos);
    console.log("numeroPreguntas:",this.numeroPreguntas);

  }

  actualizaCuestionarioTrad(event:any){
    this.actualizaJsonTrad.next(event);
  }

  completarPaso(){
    if(this.pasoCompleto){
      let textomessage = this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO');
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
    }
    else{
      if(this.numeroGrupos > 0){
        console.log("totalpreguntas",this.numeroPreguntas);

        if(this.numeroPreguntas > 0){
          if(this.gruposCompletos){
            if(this.preguntasOpcionesMinimas){
              console.log("traducciones:",this.traduccionesCompletas);
              console.log("traduccionesTab:",this.traduccionesTab);
              if (!this.traduccionesTab) {
                this.traduccionesCompletas=true;
              }
              console.log(" despues del if traducciones:",this.traduccionesCompletas);
              if(this.traduccionesCompletas){
                if(this.seccionesEspecialesOK){
                  this.aletaRestric(this.seccionActual.modal + '.COMPLETAR',true);
                } else{
                  this.aletaRestric(this.seccionActual.modal + '.FALTANTES_SECCIONES_ESPECIALES',null,'warning');
                }
              }
              else{
                this.aletaRestric(this.seccionActual.modal + '.FALTANTES_TRADUCCIONES',null,'warning');
              }
            }
            else{
              this.aletaRestric(this.seccionActual.modal + '.FALTANTES_RESPUESTAS',null,'warning');
            }
          }
          else{
            this.aletaRestric(this.seccionActual.modal + '.SIN_PREGUNTAS',null,'warning');
          }
        }
        else{
          this.aletaRestric(this.seccionActual.modal + '.SIN_PREGUNTAS',null,'warning');
        }
      }
      else{
        this.aletaRestric(this.seccionActual.modal + '.SIN_GRUPOS',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }

  desbloquearPasosSecciones(){
    let tituloDesbloquear:any;
    let confirmar: any;
    let cancelar: any;
    let succes: any;
    let bloqueado: any;
    let cerrar: any;
    let actionTexto:any;

    switch (this.seccionActual.clave) {
      case 'reactivos':
      tituloDesbloquear= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.TITULO_DESBLOQUEAR',
      confirmar= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BOTON_CONFIRM',
      cancelar= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BOTON_CANCEL',
      succes= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.SUCCES',
      bloqueado= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.BLOQUEADO',
      cerrar= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.REACTIVOS.CERRAR',
      actionTexto='DescompletePasReacti'
        break;
      case 'nps':
      tituloDesbloquear='MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.TITULO_DESBLOQUEAR';
      confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.BOTON_CONFIRM';
      cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.BOTON_CANCEL';
      succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.SUCCES';
      bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.BLOQUEADO';
      cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.NPS.CERRAR';
      actionTexto='DescompletePasNps'
        break;
      case 'control':
      tituloDesbloquear= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.TITULO_DESBLOQUEAR';
      confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.BOTON_CONFIRM';
      cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.BOTON_CANCEL';
      succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.SUCCES';
      bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.BLOQUEADO';
      cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.CONTROL.CERRAR';
       actionTexto='DescompletePasControl'
        break;
      case 'demograficos':
      tituloDesbloquear= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.TITULO_DESBLOQUEAR';
      confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.BOTON_CONFIRM';
      cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.BOTON_CANCEL';
      succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.SUCCES';
      bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.BLOQUEADO';
      cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.DEMOGRAFICOS.CERRAR';
       actionTexto='DescompletePasDemogra'
        break;
      case 'abiertas':
      tituloDesbloquear= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.TITULO_DESBLOQUEAR';
      confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BOTON_CONFIRM';
      cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BOTON_CANCEL';
      succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.SUCCES';
      bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.BLOQUEADO';
      cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ABIERTAS.CERRAR';
       actionTexto='DescompletePasAbierta'
        break;
      case 'adicionales':
      tituloDesbloquear= 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.TITULO_DESBLOQUEAR';
      confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BOTON_CONFIRM';
      cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BOTON_CANCEL';
      succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.SUCCES';
      bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BLOQUEADO';
      cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.CERRAR';
       actionTexto='DescompletePasAdicio'
        break;

      default:
        break;
    }

    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });

    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            productoId:this.productoCertificar.idCertificar,
            actualizar: 1,
          }
          datos[this.seccionActual.clave] = 2; //agrega el parametro de acuerdo al producto visualizado
          datos['accionText'] = actionTexto; //agrega el parametro de acuerdo al producto visualizado
          datos['userAdministrator'] = this.nameUserAdmin; //agrega el parametro de acuerdo al producto visualizado
          console.log("Descompletar paso",datos);
          this.preguntasService.DesbloquearPasoPorSeccion(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '211' || data.message == '219' || data.message == '220' || data.message == '214' || data.message == '221'|| data.message == '218'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               this.statusPaso.next(this.pasoCompleto);
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,

               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,

        confirmButtonText: cerrar,
        })
      }
  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:any){

    let texto = this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje);
    let rspSi = this.translateSrv.instant('MODALES.ACCIONES.aceptar');
    let rspNo = this.translateSrv.instant('MODALES.ACCIONES.cancelar');

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let actionText:string;
          let datos: any= {
    productoId:this.productoCertificar.idCertificar,
  };
          console.log("clave",this.seccionActual.clave);
          switch (this.seccionActual.clave) {
            case 'reactivos':
             actionText='completePasReacti'
              break;
            case 'nps':
             actionText='completePasNps'
              break;
            case 'control':
             actionText='completePasControl'
              break;
            case 'demograficos':
             actionText='completePasDemogra'
              break;
            case 'abiertas':
             actionText='completePasAbierta'
              break;
            case 'adicionales':
             actionText='completePasAdicio'
              break;

            default:
              break;
          }

          datos[this.seccionActual.clave] = 3; //agrega el parametro de acuerdo al producto visualizado
          datos['accionText'] = actionText; //agrega el parametro de acuerdo al producto visualizado
          datos['userAdministrator'] = this.nameUserAdmin
          datos['actualizar'] = 1,
          console.log("estos son los datos ",datos);

          this.preguntasService.guardaStatusProd(datos).subscribe( (data: any) => {
            if(data.message == this.seccionActual.codigoCompletado){
              // this.aletaRestric(this.seccionActual.modal + '.' + data.message,null,'success');
              this.openSnackBar(this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.' + this.seccionActual.modal + '.' + data.message),"OK");
              this.pasoCompleto = true;
              this.statusPaso.next(this.pasoCompleto);
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      Swal.fire({
        icon: tipo,
        title: texto,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO');
    let botonModal = this.translateSrv.instant('MODALES.ACCIONES.INFORMATIVO');
    let rspSi = this.translateSrv.instant('MODALES.ACCIONES.aceptar');
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
